var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section",attrs:{"id":"projects"}},[_c('div',{staticClass:"container"},[_vm._v("\n    Projects\n  ")])])}]

export { render, staticRenderFns }